

import React, { memo, useContext } from 'react';
import cx from 'classnames';
import { DataTableContext } from '../../context/dataTableContext';
import DataTableBodyExpanderWithDataRow from './DataTableBodyExpandWithDataRow';
import DataTableBodyTree from './DataTableBodyTree';
import { isDataTableExpanderHeightAvailable } from '../../utils/dataTableExpanderHeight';
import '../../styles/_data-table-body.scss';



const DataTableBody = () => {
  const {
    treeRowsNodes,
    styleType
  } = useContext(DataTableContext);

  return (
    <tbody className={cx('data-table-body', {
      [`data-table-body--${styleType}`]: styleType
    })}>

      <DataTableBodyTree
        treeRowsNodes={treeRowsNodes}
        isParentLastTreeRowNodeInLevel={false} />


      {
      isDataTableExpanderHeightAvailable(styleType) &&
      <DataTableBodyExpanderWithDataRow />}

    </tbody>);

};

export default memo(DataTableBody);